import "./brokerCryptoQuickButton.scss";
// @vendors
import React from "react";
import PropTypes from "prop-types";

const CryptoQuickButton = ({ onClick, icon, label }) => (
    <div className="crypto-quick-button">
        <button className="crypto-quick-button__container" onClick={onClick}>
            <i className={`icon icon-${icon} crypto-quick-button__icon`}></i>
        </button>
        <span className="crypto-quick-button__label">{label}</span>
    </div>
);

CryptoQuickButton.propTypes = {
    icon: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.string,
};

export { CryptoQuickButton };
